import { PostApiSpoSmSheetBody, SpoSmSheetResponse } from '@spo/types';
import { apiBff } from '.';

export const getSmSheet = async (
  postApiSpoSmSheetBody: PostApiSpoSmSheetBody,
): Promise<SpoSmSheetResponse> => {
  return apiBff.callBFF('POST', 'spo/sm_sheet', postApiSpoSmSheetBody);
};
